const common = {
    saveChanges: 'Save changes',
    retry: 'Retry',
    refresh: 'Refresh',
    // Navigation
    dashboard: 'Dashboard',
    products: 'Products',
    customers: 'Customers',
    analytics: 'Analytics',
    settings: 'Settings',
    billing: 'Billing',
    
    // Actions
    create: 'Create',
    edit: 'Edit',
    delete: 'Delete',
    duplicate: 'Duplicate',
    archive: 'Archive',
    save: 'Save',
    cancel: 'Cancel',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    update: 'Update',
    add: 'Add',
    manage: 'Manage',
    view: 'View',
    viewAll: 'View all',
    creating: 'Creating...',
    saving: 'Saving...',
    viewDetails: 'View Details',
    back: 'Back',
    configure: 'Configure',
    noCredits: 'No credits',
    
    // Status
    active: 'Active',
    inactive: 'Inactive',
    online: 'Online',
    offline: 'Offline',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    pending: 'Pending',
    synced: 'Synced',
    default: 'Default',
    healthy: 'healthy',
    warnings: 'warnings',
    
    // Common UI
    home: 'Home',
    about: 'About',
    contact: 'Contact',
    help: 'Help',
    profile: 'Profile',
    logout: 'Logout',
    login: 'Login',
    details: 'Details',
    description: 'Description',
    name: 'Name',
    email: 'Email',
    version: 'Version',
    status: 'Status',
    actions: 'Actions',
    tags: 'Tags',
    type: 'Type',
    translations: 'Translations',
    defaultLanguage: 'Default Language',
    originalText: 'Original Text',
    show: 'Show',
    hide: 'Hide',
    yes: 'Yes',
    no: 'No',
    or: 'OR',
    none: 'None',
    defaultValue: 'default',
    role: 'Role',
    searchPlaceholder: 'Search...',
    clearFilters: 'Clear Filters',
    noDescription: 'No description',
    errorLoadingData: 'Error loading data',
    areYouSure: 'Are you sure?',
    deleteFeatureFlagConfirmation: 'This will permanently delete the feature flag "{{name}}". This action cannot be undone.',
    deleteEndpointConfirmation: 'This action is permanent. The endpoint will be removed from the provider gateway.',
    deleteNodeConfirmation: 'This will permanently delete the automation node. You cannot undo this action.',
    
    // Time
    minAgo: '{{count}} min ago',
    hours24: '24h',
    never: 'Never',
    lastUsed: 'Last used',
    
    // Numbers
    operations: 'operations',
    endpoints: 'Endpoints',
    
    // Buttons
    startFreeTrial: 'Start free trial',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    helpSupport: 'Help & Support',
    close: 'Close',
    comingSoonNotice: 'This feature is currently under development and will be available soon.',
  } as const;

export default common;
